/**
 * Desktop mega panels share min-height = max natural height so hover swaps don't resize the bar (header.css).
 * Transition is suppressed while restoring display, else `transition: display allow-discrete` flashes the panel.
 */

const CSS_VAR = '--header-mega-menu-unified-height';

function measureMegaNaturalHeight(mega: HTMLElement, widthPx: number): number {
  const prev = {
    position: mega.style.position,
    visibility: mega.style.visibility,
    pointerEvents: mega.style.pointerEvents,
    left: mega.style.left,
    top: mega.style.top,
    width: mega.style.width,
    height: mega.style.height,
    display: mega.style.display,
    opacity: mega.style.opacity,
    transition: mega.style.transition,
  };

  mega.style.position = 'fixed';
  mega.style.visibility = 'hidden';
  mega.style.pointerEvents = 'none';
  mega.style.left = '-10000px';
  mega.style.top = '0';
  mega.style.width = `${widthPx}px`;
  mega.style.height = 'auto';
  mega.style.display = 'block';
  mega.style.opacity = '1';

  const h = mega.offsetHeight;

  mega.style.transition = 'none';
  mega.style.position = prev.position;
  mega.style.visibility = prev.visibility;
  mega.style.pointerEvents = prev.pointerEvents;
  mega.style.left = prev.left;
  mega.style.top = prev.top;
  mega.style.width = prev.width;
  mega.style.height = prev.height;
  mega.style.display = prev.display;
  mega.style.opacity = prev.opacity;
  void mega.offsetHeight;
  mega.style.transition = prev.transition;

  return h;
}

export function initMegaMenuUnifiedHeight(headerEl: HTMLElement): void {
  const main = headerEl.querySelector<HTMLElement>('[data-main]');
  const nav = headerEl.querySelector<HTMLElement>('[data-main] nav');
  if (!main || !nav) return;

  let rafId = 0;

  const sync = () => {
    const megas = Array.from(headerEl.querySelectorAll<HTMLElement>('.header__mega-menu'));
    if (megas.length === 0) {
      headerEl.style.removeProperty(CSS_VAR);
      return;
    }

    const navCs = getComputedStyle(nav);
    if (navCs.display === 'none' || nav.clientWidth === 0) {
      headerEl.style.removeProperty(CSS_VAR);
      return;
    }

    const widthPx = main.clientWidth;
    if (widthPx <= 0) {
      headerEl.style.removeProperty(CSS_VAR);
      return;
    }

    let maxH = 0;
    for (const mega of megas) {
      maxH = Math.max(maxH, measureMegaNaturalHeight(mega, widthPx));
    }

    if (maxH > 0) {
      headerEl.style.setProperty(CSS_VAR, `${maxH}px`);
    } else {
      headerEl.style.removeProperty(CSS_VAR);
    }
  };

  const scheduleSync = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      sync();
    });
  };

  new ResizeObserver(scheduleSync).observe(main);
  void document.fonts?.ready?.then(scheduleSync);
  scheduleSync();
}
